import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Animatable
} from "./chunk.LXK2U27H.js";
import {
  JBCookie,
  getEventElement
} from "./chunk.PSCGDE4H.js";
import {
  D,
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  n,
  r as r3
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-e-service-overlay/jb-e-service-overlay.scss?inline
var jb_e_service_overlay_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.links, h4 {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h4 {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 1.375rem;
  letter-spacing: calc(var(--letter-spacing-factor, 3) * 0.063rem);
  line-height: 2.25rem;
}
@media (min-width: 1281px) {
  h4 {
    font-size: 1.75rem;
    letter-spacing: calc(var(--letter-spacing-factor, 4) * 0.063rem);
    line-height: 2.5rem;
  }
}

/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  background-color: #141e55;
  display: block;
  min-height: calc(100vh - 60px);
}
@media (min-width: 600px) {
  :host {
    min-height: calc(100vh - 90px);
  }
}
@media (min-width: 960px) {
  :host {
    height: 100%;
  }
}
@media (min-width: 1281px) {
  :host {
    min-height: calc(100vh - 100px);
  }
}

.eservices {
  --_notch-inset: calc(max(env(safe-area-inset-left), env(safe-area-inset-right)) + 5px);
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  opacity: 0;
  padding-bottom: 112px;
  padding-inline: max(32px, var(--_notch-inset));
  padding-top: calc(112px - 60px);
  position: relative;
}
@media (min-width: 600px) {
  .eservices {
    padding-top: calc(112px - 90px);
  }
}
@media (min-width: 960px) {
  .eservices {
    padding-top: 78px;
  }
}
@media (min-width: 1281px) {
  .eservices {
    padding-inline: 22px;
    padding-top: 68px;
  }
}

.locationselect {
  width: 100%;
  z-index: 2;
}
@media (min-width: 960px) {
  .locationselect {
    align-items: center;
    display: flex;
    width: auto;
  }
}
.locationselect .ts-dropdown {
  transform: translateY(-1px);
}

h4 {
  color: #fff;
  font-size: 1.625rem;
  letter-spacing: normal;
  margin-bottom: 8px;
  white-space: nowrap;
  width: 100%;
}
@media (min-width: 600px) {
  h4 {
    font-size: 1.75rem;
    margin-bottom: 0;
    margin-right: 8px;
    width: auto;
  }
}
@media (min-width: 960px) {
  h4 {
    font-size: 28px;
    font-size: 1.75rem;
    line-height: 40px;
    line-height: 2.5rem;
    margin-top: 0;
  }
}

.links {
  box-sizing: border-box;
  flex-basis: 100%;
  max-width: 100%;
  padding: 0 0;
  width: 100%;
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  flex-wrap: wrap;
  margin-inline: auto;
  margin-top: 48px;
  row-gap: 48px;
}
@media (min-width: 960px) {
  .links {
    box-sizing: border-box;
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    padding: 0 0;
    width: 66.6666666667%;
    margin-left: 16.6666666667%;
    flex-direction: row;
    gap: 64px 40px;
    margin-inline: auto;
    margin-top: 64px;
    max-width: calc(66.6667% + 30px);
    width: calc(66.6667% + 30px);
  }
}
@media (min-width: 1281px) {
  .links {
    box-sizing: border-box;
    flex-basis: 50%;
    max-width: 50%;
    padding: 0 0;
    width: 50%;
    max-width: 812px;
  }
}
.links h5 {
  border-bottom: 1px solid rgba(255, 255, 255, var(--theme-opacity-70, 0.7));
  color: rgba(255, 255, 255, var(--theme-opacity-70, 0.7));
  font-size: 1.188rem;
  font-weight: 300;
  line-height: 2.125rem;
  margin-bottom: 32px;
  padding-bottom: 8px;
}
.links h6 {
  color: rgba(255, 255, 255, var(--theme-opacity-70, 0.7));
  font-size: 0.688rem;
  font-weight: 400;
  letter-spacing: 0.063rem;
  line-height: 16px;
  text-transform: uppercase;
}
.links ul {
  list-style: none;
  margin: 20px 0;
  padding: 0;
}
.links li {
  margin-bottom: 24px;
}
.links .individuals,
.links .intermediaries {
  flex: 1;
}
.links .furtherlinks {
  flex-basis: 100%;
}
@media (min-width: 960px) {
  .links .furtherlinks:not(.multiple) {
    display: none;
  }
}

.furtherlink {
  display: none;
}
@media (min-width: 960px) {
  .furtherlink {
    bottom: 80px;
    display: block;
    position: absolute;
    right: 128px;
  }
}`;

// src/components/jb-e-service-overlay/jb-e-service-overlay.ts
var JbEServiceOverlay = class extends Initiable(Animatable(r2)) {
  firstUpdated() {
    this._cookieCountry = JBCookie.getI18nCookieData().country;
    this._eServiceLocations = this.eServiceData?.map((location, index) => ({
      value: index + "",
      label: location.headline
    }));
    this.eServiceData?.forEach((data, index) => {
      if (this._cookieCountry && data.preselectForCountries.includes(this._cookieCountry)) {
        this._locationValue = index + "";
        this._setServices(index);
      }
    });
  }
  _selectChanged(evt) {
    this._setServices(evt.detail.newValue);
  }
  _sendTrackingClick(text, url, subtitle = "") {
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_interaction",
          event_version: "v2",
          component_name: "header",
          interaction_effect: "navigation",
          interaction_element: subtitle ? `${subtitle}:${text.replace(/\s+/g, "-").toLowerCase()}` : text.replace(/\s+/g, "-").toLowerCase(),
          interaction_result: url,
          interaction_text: `e-services__${this._currentData.headline.replace(/\s+/g, "-").toLowerCase()}__${subtitle ? subtitle + ":" : ""}${text.replace(/\s+/g, "-").toLowerCase()}`,
          interaction_type: "click"
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _setServices(index) {
    if (!this.eServiceData) {
      return;
    }
    this._currentData = this.eServiceData[index];
  }
  _trackAllServicesClick(customEvent) {
    customEvent.stopPropagation();
    customEvent.detail.clickEvent.stopPropagation();
    this._sendTrackingClick(
      getEventElement(customEvent, "JB-BUTTON-TERTIARY").textContent ?? "",
      getEventElement(customEvent, "A").getAttribute("href")
    );
  }
  _trackIndividualClick(customEvent) {
    customEvent.stopPropagation();
    customEvent.detail.clickEvent.stopPropagation();
    this._sendTrackingClick(
      getEventElement(customEvent, "JB-BUTTON-TERTIARY").textContent ?? "",
      getEventElement(customEvent, "A").getAttribute("href"),
      "for-individuals"
    );
  }
  _trackIntermediaryClick(customEvent) {
    customEvent.stopPropagation();
    customEvent.detail.clickEvent.stopPropagation();
    this._sendTrackingClick(
      getEventElement(customEvent, "JB-BUTTON-TERTIARY").textContent ?? "",
      getEventElement(customEvent, "A").getAttribute("href"),
      "for-intermediaries"
    );
  }
  render() {
    return ke`
      <div class="eservices">
        <div class="locationselect">
          <h4>${this.headline}</h4>
          ${this._eServiceLocations ? ke`<jb-select
                @jb-select:changed=${this._selectChanged}
                .options=${this._eServiceLocations}
                .value=${this._locationValue}
                .placeholder=${this.pleaseSelect}
                type="iseservices"
                tabindex="0"
              >
              </jb-select>` : D}
        </div>
        ${this._currentData ? ke`
              <div class="links">
                ${this._currentData.forIndividuals.links?.length > 0 ? ke`<div class="individuals">
                      <h5>${this._currentData.forIndividuals.headline}</h5>
                      ${this._currentData.forIndividuals.cta ? ke`<h6>${this._currentData.forIndividuals.cta}</h6>` : D}
                      <ul>
                        ${this._currentData.forIndividuals.links.map(
      (link) => ke`<li>
                              <jb-button-tertiary
                                @jb-link:clicked=${this._trackIndividualClick}
                                inverted
                                .link=${link.link}
                                >${link.text}</jb-button-tertiary
                              >
                            </li>`
    )}
                      </ul>
                    </div>` : D}
                ${this._currentData.forIntermediaries && this._currentData.forIntermediaries.links.length > 0 ? ke`
                      <div class="intermediaries">
                        <h5>${this._currentData.forIntermediaries.headline}</h5>
                        ${this._currentData.forIntermediaries.cta ? ke`<h6>${this._currentData.forIntermediaries.cta}</h6>` : D}
                        <ul>
                          ${this._currentData.forIntermediaries.links.map(
      (link) => ke`<li>
                                <jb-button-tertiary
                                  @jb-link:clicked=${this._trackIntermediaryClick}
                                  inverted
                                  .link=${link.link}
                                  >${link.text}</jb-button-tertiary
                                >
                              </li>`
    )}
                        </ul>
                      </div>
                    ` : D}
                ${this._currentData.furtherLinks ? ke`<div
                      class="${Rt({
      furtherlinks: true,
      multiple: this._currentData.furtherLinks.links.length > 1
    })}"
                    >
                      <h5>${this._currentData.furtherLinks?.headline}</h5>
                      ${this._currentData.furtherLinks?.cta ? ke`<h6>${this._currentData.furtherLinks?.cta}</h6>` : D}
                      <ul>
                        ${this._currentData.furtherLinks?.links.map(
      (link) => ke`<li>
                              <jb-button-tertiary
                                @jb-link:clicked=${this._trackAllServicesClick}
                                inverted
                                .link=${link.link}
                                >${link.text}</jb-button-tertiary
                              >
                            </li>`
    )}
                      </ul>
                    </div>` : D}
              </div>
              ${this._currentData.furtherLinks && this._currentData.furtherLinks.links.length === 1 ? ke`<jb-button-tertiary
                    class="furtherlink"
                    @jb-link:clicked=${this._trackAllServicesClick}
                    inverted
                    .link=${this._currentData.furtherLinks.links[0].link}
                    >${this._currentData.furtherLinks.links[0].text}</jb-button-tertiary
                  >` : D}
            ` : D}
      </div>
    `;
  }
};
JbEServiceOverlay.styles = r(jb_e_service_overlay_default);
JbEServiceOverlay.shadowRootOptions = { ...r2.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Array })
], JbEServiceOverlay.prototype, "eServiceData", 2);
__decorateClass([
  n()
], JbEServiceOverlay.prototype, "headline", 2);
__decorateClass([
  n()
], JbEServiceOverlay.prototype, "pleaseSelect", 2);
__decorateClass([
  r3()
], JbEServiceOverlay.prototype, "_currentData", 2);
__decorateClass([
  r3()
], JbEServiceOverlay.prototype, "_eServiceLocations", 2);
JbEServiceOverlay = __decorateClass([
  customElement("jb-e-service-overlay")
], JbEServiceOverlay);

export {
  JbEServiceOverlay
};
